import React               from "react";
import Grid                from '@mui/material/Grid';
import '../app.min.css';

export default function MainTitle () {
	return (
		<div className="mainTitle">
		<Grid spacing={1} container>
			<Grid item xs={false} md={2}>
			</Grid>
			<Grid item xs={false} md={10}>
				<h1 className="mainTitle">All about Foreign Scholarships, Admissions and Useful Tips</h1>
			</Grid>
		</Grid>
		</div>
	);
}
